import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class VideoPlayer {

  constructor(videoContainer) {
    const self = this
    this.video = $(videoContainer + ' video')[0]
    this.progressBar = $(videoContainer + ' .svg-bar')
    this.percent = 0

    if (this.video && this.video.paused) {
      $(this).toggleClass('is-playing')
    }

    this.video.addEventListener('timeupdate', () => {

      this.percent = (this.video.currentTime / (this.video.duration - .30)) * 100

      if (this.percent > 100) {
        this.percent = 100
        this.progressBar.addClass('reset')

        setTimeout(function () {
          self.progressBar.removeClass('reset')
        }, 400)

      }

      this.progress(this.percent)

    })

    $('body').on('click', videoContainer + ' .btn-play-pause', function () {
      $(this).toggleClass('is-playing')
      if ($(this).hasClass('is-playing')) {
        self.play()
      } else {
        self.pause()
      }
    })

    if ($(videoContainer).find('.js--custom-small-video-cursor').length > 0) {
      const thisVideoButton = $(videoContainer).find('.js--custom-small-video-cursor')

      $(videoContainer).on('mousemove', function (event) {
        if ($(window).width() >= 1280) {

          var offset = $(this).offset();
          var relativeX = event.pageX - offset.left;
          var relativeY = event.pageY - offset.top;
          var rectHeight = $(videoContainer).find('.svg-rect').outerHeight() / 2
          var rectHeightRotated = Math.sqrt(2) * rectHeight;

          if (relativeX - rectHeightRotated < 0 || relativeY - rectHeightRotated < 0 || relativeX + rectHeightRotated > $(this).width() || relativeY + rectHeightRotated > $(this).outerHeight()) {
            thisVideoButton.removeClass('shown');
          } else {
            thisVideoButton.addClass('shown');
          }
          gsap.set(thisVideoButton, {left: relativeX, top: relativeY});

        }
      });

      $(videoContainer).on('mouseleave', function () {
        thisVideoButton.removeClass('shown')
      });
    }

    this.optimize(videoContainer)
  }

  play() {
    if (this.video) {
      this.video.play()
    }
  }

  pause() {
    if (this.video && this.video) {
      this.video.pause()
    }
  }

  mute(isMuted) {
    if (this.video) {
      this.video.muted = isMuted
    }
  }

  progress(percent) {
    var val = percent
    var $circle = this.progressBar

    if (isNaN(val)) {
      val = 100;
    } else {
      var r = $circle.attr('r');
      var c = Math.PI * (r * 2);

      if (val < 0) {
        val = 0;
      }
      if (val > 100) {
        val = 100;
      }

      var pct = ((100 - val) / 100) * c;

      $circle.css({strokeDashoffset: pct})

    }
  }

  optimize(videoContainer) {

    let self = this
    let isSignBlock = $(videoContainer).hasClass('short-video')
    ScrollTrigger.create({
      trigger: videoContainer,
      scrub: true,
      start: 'top bottom',
      end: isSignBlock ? 'bottom+=1000vh top' : 'bottom top',
      // markers: true,
      onEnter: () => {
        self.play()
      },
      onLeave: () => {
        self.pause()
      },
      onEnterBack: () => {
        self.play()
      },
      onLeaveBack: () => {
        self.pause()
      }
    })

  }

}

export {VideoPlayer}

